import { extractStringFromCellValue } from "./extractStringFromCellValue";

export const convertTableDataToBarChartFormat = (tableData) => {
  if (!tableData?.data || !Array.isArray(tableData.data)) {
    return [];
  }

  return tableData.data
    .map((row, index) => {
      const keyCell = row.cellData[0]; 
      const valueCell = row.cellData[1]; 
      

      const keyString = extractStringFromCellValue(keyCell?.value);
      const value = valueCell?.value;
      

      if (!keyString.trim() || value === '' || value === null || value === undefined) {
        return null;
      }


      const numericValue = typeof value === 'number' ? value : parseFloat(value);
      if (isNaN(numericValue) || numericValue < 0) {
        return null;
      }
      
      return {
        display: keyString.trim(),
        value: numericValue
      };
    })
    .filter(item => item !== null); 
};